import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Rating, RatingChangeEvent } from '@progress/kendo-react-inputs';
import { useContext, useState } from 'react';
import { PageContext } from './PageContext';
import { Label } from '@progress/kendo-react-labels';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { Notification } from '@progress/kendo-react-notification';
import { changePassword } from '../services/apiAdminService';

interface ChangePasswordProps {
    username:string;
    onClose:()=>void;
}
export function ChangePassword(props:ChangePasswordProps){

const [pw,setPw]=useState("");
const [pwConf,setPwConf]=useState("");
const [pwMatch, setPwMatch]=useState(false);
const [pwValid, setPwValid]=useState(false);
const [notifyMessage,setNotifyMessage]=useState("");
const [showNotfy,setShowNotify]=useState(false);

const validatePW=()=>{
    
    var result=true;
    if (pw!=pwConf){
        updateNotify("Passwords do not match");
        openNotify();
        result=(false);
    }else{
        //strong password validation
        const criteria = [
            { regex: /(?=.*[A-Z])/, message: "At least one uppercase letter required" },
            { regex: /(?=.*[a-z])/, message: "At least one lowercase letter required" },
            { regex: /(?=.*\d)/, message: "At least one number reuired" },
            { regex: /(?=.*[!@#$%^&*])/, message: "At least one special character required" },
            { regex: /.{8,}/, message: "Minimum 8 characters required" },
        ];
        const validationResults = criteria.map((criterion) => ({
            isValid: criterion.regex.test(pw),
            message: criterion.message,
        }));
        console.log(validationResults);

        validationResults.map(criteria=>{
            if (!criteria.isValid){
                updateNotify(criteria.message);
                openNotify();
                result=false;
            }
        })
    }
    if (result==true){
        closeNotify();
    }
    return (result);
}

const updateNotify=(message:string)=>{
    setNotifyMessage(message);
}

const openNotify=()=>{
    setShowNotify(true);
}

const closeNotify=()=>{
    setShowNotify(false);
}

const handleConfirm=()=>{
    var isValid = validatePW();
    if (isValid){
        console.log("Password is valid");
        changePassword(props.username, pw).then(data=>{
            props.onClose();
        });
    }else{
        console.log("Validation failed");
    }
}

const pwOnChange=(e:InputChangeEvent)=>{
    setPw(e.value);
}

const pwConfOnChange=(e:InputChangeEvent)=>{
    setPwConf(e.value);
}


return(
        <Dialog title="Change User Password" onClose={props.onClose}>
            {showNotfy?<Notification type={{style:"error"}}>{notifyMessage}</Notification>:null}
            <div className='mb-2'>Changing the password for user: {props.username}</div>
            <div>
                <Label>New Password</Label>
                <Input type="password" onChange={pwOnChange} value={pw}></Input>
            </div>
            <div>
                <Label>Confirm Password</Label>
                <Input type="password" onChange={pwConfOnChange} value={pwConf}></Input>
            </div>
            <DialogActionsBar>
                <Button onClick={handleConfirm}>Save</Button>
                <Button onClick={props.onClose}>Cancel</Button>
            </DialogActionsBar>
        </Dialog>
    )
}